import angular from 'angular';
import benefitTypeDescriptionModal from './benefitTypeDescriptionModal';
import './style.scss';

export default angular
  .module('components.benefitTypeDescriptionModal', [])
  .component('benefitTypeDescriptionModal', benefitTypeDescriptionModal).name;
